export default "__VITE_ASSET__C3lArP2Q__"